import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-[oklch(var(--background-50)_/_0.95)] backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span className="text-xl font-bold font-heading text-[oklch(var(--foreground-950))]">
              韩漫网
            </span>
            <span className="hidden sm:inline text-xs text-[oklch(var(--foreground-600))] bg-[oklch(var(--background-100))] px-2 py-0.5 rounded-full whitespace-nowrap">
              免费漫画大全
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm whitespace-nowrap transition-colors ${
                isActive('/') && location.pathname === '/'
                  ? 'text-[oklch(var(--primary-500))] font-semibold'
                  : 'text-[oklch(var(--foreground-700))] hover:text-[oklch(var(--primary-500))]'
              }`}
            >
              首页
            </Link>
            <Link
              to="/category/romance"
              className={`text-sm whitespace-nowrap transition-colors ${
                isActive('/category')
                  ? 'text-[oklch(var(--primary-500))] font-semibold'
                  : 'text-[oklch(var(--foreground-700))] hover:text-[oklch(var(--primary-500))]'
              }`}
            >
              分类
            </Link>
            <Link
              to="/about"
              className={`text-sm whitespace-nowrap transition-colors ${
                isActive('/about')
                  ? 'text-[oklch(var(--primary-500))] font-semibold'
                  : 'text-[oklch(var(--foreground-700))] hover:text-[oklch(var(--primary-500))]'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="打开菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'} text-[oklch(var(--foreground-950))]`} />
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-[oklch(var(--background-50))] border-t border-[oklch(var(--background-200)_/_0.7)]">
          <div className="px-4 py-4 flex flex-col gap-3">
            <Link to="/" className="text-sm py-2 text-[oklch(var(--foreground-700))] hover:text-[oklch(var(--primary-500))]">
              首页
            </Link>
            <Link to="/category/romance" className="text-sm py-2 text-[oklch(var(--foreground-700))] hover:text-[oklch(var(--primary-500))]">
              分类浏览
            </Link>
            <Link to="/about" className="text-sm py-2 text-[oklch(var(--foreground-700))] hover:text-[oklch(var(--primary-500))]">
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}